/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const ingestionStatusEnum = {
  PRODUCTS_PRE_VERIFIED: "PRODUCTS_PRE_VERIFIED",
  PENDING: "PENDING",
  BLANK_PRODUCTS_VERIFIED: "BLANK_PRODUCTS_VERIFIED",
  BLANK_PRODUCTS_INGESTED: "BLANK_PRODUCTS_INGESTED",
  PRODUCTS_VERIFIED: "PRODUCTS_VERIFIED",
  PRODUCTS_INGESTED: "PRODUCTS_INGESTED",
  PROCESSED: "PROCESSED",
  ERROR: "ERROR",
  FAILED: "FAILED",
  BUSINESS_PARTNER_VERIFIED: "BUSINESS_PARTNER_VERIFIED",
  BUSINESS_PARTNER_INGESTED: "BUSINESS_PARTNER_INGESTED",
  ECO_MODULATION_INGESTED: "ECO_MODULATION_INGESTED",
} as const

export type IngestionStatusEnumKey =
  (typeof ingestionStatusEnum)[keyof typeof ingestionStatusEnum]

export type IngestionStatus = IngestionStatusEnumKey
